import React, { useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../admin/api";

function BookDemo({ show, handleClose, productName = "" }) {

  const [formData, setFormData] = React.useState({
    product: "",
    businessName: "",
    contactNo: "",
    email: "",
    requirement: ""
  });

  // 🔹 Auto bind product
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      product: productName
    }));
  }, [productName]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const res = await api.post("/UiplusDemoRequests", formData);

    if (res.status === 200 || res.status === 201) {
      toast.success("Demo request submitted successfully");

      // 🔹 Reset form
      setFormData({
        product: "",
        businessName: "",
        contactNo: "",
        email: "",
        requirement: ""
      });

      handleClose();
    } else {
      toast.error("❌ Failed to submit");
    }

  } catch (error) {
    console.error("API Error:", error);

    // 🔹 Show backend error if available
    const msg =
      error.response?.data || "Something went wrong. Please try again";

    toast.error("❌ " + msg);
  }
};

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Book a Product Demo</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>

          {/* Product */}
          <Form.Group className="mb-3">
            <Form.Label>Product</Form.Label>
            <Form.Control
              type="text"
              name="product"
              value={formData.product}
              readOnly
            />
          </Form.Group>

          {/* Business Name */}
          <Form.Group className="mb-3">
            <Form.Label>Business Name</Form.Label>
            <Form.Control
              type="text"
              name="businessName"
              value={formData.businessName}
              onChange={handleChange}
              required
            />
          </Form.Group>

          {/* Contact */}
          <Form.Group className="mb-3">
            <Form.Label>Contact No</Form.Label>
            <Form.Control
              type="tel"
              name="contactNo"
              value={formData.contactNo}
              onChange={handleChange}
              required
            />
          </Form.Group>

          {/* Email */}
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </Form.Group>

          {/* Requirement */}
          <Form.Group className="mb-3">
            <Form.Label>Your Requirement</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="requirement"
              value={formData.requirement}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <div className="text-end">
            <Button type="submit" variant="primary">
              Submit Request
            </Button>
          </div>

        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default BookDemo;
